import React, { useState } from 'react'
import { connect } from 'react-redux'
import { connectResource } from '../utils/resource'
import { compose } from 'redux'
import classnames from 'classnames'

import SidebarOnlyLayout from './SidebarOnlyLayout'
import { updateHamburgerMenu } from '../socket/actions'

const SidebarOnlyLayoutContainer = (props) => {
  const [sidebarHidden, setSidebarHidden] = useState(props.updateHamburgerMenu === 'closed')
  const [minimize, setMinimize] = useState(true)
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleSidebar = () => {
    const newSidebarHidden = !sidebarHidden
    setSidebarHidden(newSidebarHidden)
    props.dispatch(updateHamburgerMenu(newSidebarHidden))
  }

  const toggleMinimizeSidebar = () => {
    setMinimize(!minimize)
  }

  const toggleDropdown = key => {
    setOpenDropdown(openDropdown === key ? null : key)
  }

  const dropdown = {}
  if (openDropdown) {
    dropdown[openDropdown] = true
  }

  return (
    <SidebarOnlyLayout
      {...props}
      sidebarHidden={sidebarHidden}
      minimize={minimize}
      dropdown={dropdown}
      toggleSidebar={toggleSidebar}
      toggleMinimizeSidebar={toggleMinimizeSidebar}
      toggleDropdown={toggleDropdown}
      appClassName={classnames('app', {
        'sidebar-hidden': sidebarHidden,
        'brand-minimized sidebar-minimized': minimize,
      })}
    />
  )
}

function mapStateToProps(state) {
  return {
    updateHamburgerMenu: state.app.updateHamburgerMenu,
  }
}

export default compose(
  connectResource(
    { namespace: 'user', endpoint: 'users', prefetch: false }
  ),
  connect(null, (dispatch) => ({ dispatch })),
  connect(mapStateToProps)
)(SidebarOnlyLayoutContainer)
